import { FC, useCallback, useState } from "react"
import { matrimonyProfileDeleteApi } from "src/domain/api/matrimonyProfile/matrimonyProfileDeleteApi"
import { MatrimonyProfile } from "src/domain/entities/matrimonyProfile"
import { useAuth } from "../../../domain/hooks"
import { getErrorMessage } from "../../../utils/helpers"
import DeleteItemDialog from "../../shared/DeleteItemDialog"

interface Props {
	matrimonyProfile: MatrimonyProfile
	isOpen: boolean
	setIsOpen: (isOpen: boolean) => void
	onSuccess?: () => void
}

export const MatrimonyProfileDeleteDialogController: FC<Props> = ({
	isOpen,
	setIsOpen,
	matrimonyProfile,
	onSuccess,
}) => {
	const { token } = useAuth()
	const [isLoading, setIsLoading] = useState(false)
	const [errorMessage, setErrorMessage] = useState<string | null>(null)

	const handleMatrimonyProfileDelete = useCallback(async () => {
		try {
			setIsLoading(true)
			await matrimonyProfileDeleteApi({ id: matrimonyProfile.id }, token)
			setIsOpen(false)
			onSuccess && onSuccess()
		} catch (err) {
			setErrorMessage(getErrorMessage(err))
		} finally {
			setIsLoading(false)
		}
	}, [matrimonyProfile, setIsOpen, token, onSuccess])

	return (
		<DeleteItemDialog
			title={`Delete Profile: ${matrimonyProfile.profile?.firstName.en}`}
			isOpen={isOpen}
			onCancel={() => {
				setIsOpen(false)
				setErrorMessage(null)
			}}
			onDelete={handleMatrimonyProfileDelete}
			isLoading={isLoading}
			errorMessage={errorMessage}
		/>
	)
}
